
<timer-since class="flex-align-center" [since]="agent?.status_since"></timer-since>
